module.exports = __webpack_public_path__ + "static/photo1-ddd6f7180a7d8ddfefaadeabacc50d2d.jpg";